import type { ICompasAIChatAction } from "@/types/compass.types";

export async function processCompassStream(
  stream: ReadableStream<Uint8Array>
): Promise<ICompasAIChatAction[]> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  const actions: ICompasAIChatAction[] = [];

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    const lines = decoder
      .decode(value, { stream: true })
      .split("\n")
      .filter((l) => l.trim());
    for (const line of lines) {
      try {
        const data: unknown = JSON.parse(line);
        if (typeof data === "object" && data != null && "type" in data && data.type === "action")
          actions.push(data as ICompasAIChatAction);
      } catch (_e) {
        /* skip */
      }
    }
  }
  return actions;
}
